import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./main.css";
import "./popular.css";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../Features/cart/cartslice";
import { BsHeart, BsFillBookmarkHeartFill } from "react-icons/bs";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { PacmanLoader } from "react-spinners";

const Popular = () => {
  const [popularMovies, setPopularMovies] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [visible, setVisible] = useState(10);
  const [alreadyPresentInCart, setAlreadyPresentInCart] = useState(false);

  const itemsInCart = useSelector((state) => state.cart.cart);

  useEffect(() => {
    setIsLoading(true);
    fetch(
      "https://api.themoviedb.org/3/movie/top_rated?api_key=375735221c3b7b45a786c79616eae571&language=en-US"
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data.results);
        setPopularMovies(data.results);
        setIsLoading(false);
      });
  }, []);

  function loadMoreHandler() {
    // setVisible((prevValue) => prevValue + 5);
    const loadMore = document.querySelector(".load__more");
    setVisible((prevValue) => {
      const updatedValue = prevValue + 5;
      console.log("Updated value:", updatedValue);
      if (updatedValue === popularMovies.length) {
        // console.log("reached max");
        loadMore.style.display = "none";
      } else {
        // console.log("not max");
        loadMore.style.display = "flex";
      }
      return updatedValue;
    });
  }

  const dispatch = useDispatch();

  function addToWislist(product) {
    // Check if the movie is already in the cart
    const isMovieAlreadyAdded = itemsInCart.some(
      (item) => item.id === product.id
    );
    if (isMovieAlreadyAdded) {
      // Show a message or handle the duplicate case here
      setAlreadyPresentInCart(true);
    } else {
      // Dispatch the addToCart action if the movie is not in the cart
      dispatch(addToCart(product));
    }
  }

  return (
    <>
      {!isLoading && (
        <div className="main-movie-container">
          <div className="card__title">
            <p className="title-section">Popular Movies</p>
          </div>
          {alreadyPresentInCart && (
            <div
              onClick={() => setAlreadyPresentInCart(false)}
              className="already-present-message-box"
            >
              <p>
                Movie Already In Watchlist
                <span onClick={() => setAlreadyPresentInCart(false)}>
                  <AiOutlineCloseCircle />
                </span>
              </p>
            </div>
          )}

          <div className="popular">
            {popularMovies.slice(0, visible).map((movie) => {
              return (
                <div className="main___container">
                  <Link key={movie.id} to={`/movie/${movie.id}`}>
                    <div className="card">
                      <img
                        className="card-image design-image"
                        src={`https://image.tmdb.org/t/p/original${movie.poster_path}`}
                        alt="movie"
                      />
                      <div className="card__content">
                        <p className="card-title">{movie.original_title}</p>
                        <p className="card_rating">
                          {" "}
                          {movie.vote_average} <i className="fa fa-star"></i>
                        </p>
                        <p className="card_desc">{movie.overview}</p>
                      </div>
                    </div>
                  </Link>
                  <div className="add-to-wishlist-box">
                    <button
                      className="add_to_wishlist"
                      onClick={() => addToWislist(movie)}
                    >
                      <BsFillBookmarkHeartFill />
                    </button>
                    <p className="add-to-wishlist-text">Add To Watchlist</p>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="button load__more">
            <button onClick={loadMoreHandler}>Load More</button>
          </div>
        </div>
      )}
      {isLoading && (
        <p
          style={{
            fontSize: "50px",
            color: "red",
            textAlign: "center",
            marginTop: "50px",
            padding: "100px 0",
            fontWeight: "bold",
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <PacmanLoader color="#FFFF00" />
          Loading
        </p>
      )}
    </>
  );
};

export default Popular;
